import ko = require("knockout");
import EmailComposer = require("./emailComposer");

export class EmailComposerRegistration {
    private static isRegistered: boolean;
    public static register() {
        if (!EmailComposerRegistration.isRegistered) {
            console.log("email composer registration in progress");
            ko.components.register("email-composer", {
                viewModel: {
                    createViewModel: function (params, componentInfo) {
                        return new EmailComposer.EmailComposerViewModel(params, componentInfo);
                    }
                },
                template: require("./emailComposer.html")
            });
            EmailComposerRegistration.isRegistered = true;
        } else {
            console.log("email composer picker already registered");
        }
    }
}
